<template>
    <div class="footer">
        <div class="row">
            <i class="nomobile material-icons">tty</i>
            <span class="nomobile support-email">{{supportEmail}}</span>
            <span class="nomobile">{{schedule ? schedule : tokens.footer.supportBanner }}</span>
            <span class="deposit" @click="showCabinetPage('deposit')" v-show="isMobile">{{tokens.fullScreen.deposit.toUpperCase()}}</span>
        </div>
        <div class="row pads">
            <div v-if="footerRedirectButton && website" class="row website-link">
                <a :href="website" target="_blank">
                    <i class="material-icons">open_in_new</i> 
                </a>
            </div>
            <div class="row app-download" v-if="varNames.APPLICATION_DOWNLOAD_LINK">
                <a :href="varNames.APPLICATION_DOWNLOAD_LINK" target="_blank">
                    <img :src="staticBase + `aspin-design/cloud-download-i.png`">
                </a>
            </div>
            <div class="row live-chat" :class="{blinking: unreadMessageCounter !== '0' && supportUnread}" v-if="user.enable_chat && !newChat " @click="showCabinetPage('support')">
                <i class="material-icons">mail_outline</i>
                <span>{{ tokens.footer.liveChat.toUpperCase() }} {{unreadMessageCounter === '0' || !supportUnread ? '' : `(${unreadMessageCounter})`}}</span>
            </div>
            <div class="row live-chat" :class="{blinking: unreadMessageCounter !== '0' && supportUnread}" v-else-if="user.enable_chat && newChat" @click="showSupportModal">
                <i class="material-icons">mail_outline</i>
                <span>{{ tokens.footer.liveChat.toUpperCase() }} {{unreadMessageCounter === '0' || !supportUnread ? '' : `(${unreadMessageCounter})`}}</span>
            </div>
            <i class="material-icons" @click="toggleMute">{{mute ? 'volume_off' : 'volume_up'}}</i>
            <i class="material-icons" @click="showCabinetPage('settings')">settings</i>
            <span class="nomobile">{{ tokens.footer.currentTime }}: {{ new Date(time).toLocaleString() }}</span>
            <i class="material-icons" @click="fullscreen">fullscreen</i>
        </div>

        <SupportModal  v-if="supportModalIsOpen" :supportModalIsOpen="supportModalIsOpen" @close-modal="closeSupportModal"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {SUPPORT_EMAIL, SCHEDULE, NEW_CHAT, WEBSITE, FOOTER_REDIRECT_BUTTON} from "@/common/config";
    import {requestFullScreen, isMobile} from "@/common/helpers";
    import {MODAL, MODAL_FULLSCREEN, MUTE} from "@/store/mutations.type";
    import SupportModal from './Modals/SupportModal.vue';

    export default {
        name: "Footer",
        components:{SupportModal},
        mounted() {
            setInterval(() => {
                this.time = Date.now()
            }, 1000)
        },
        data() {
            return {
                supportEmail: SUPPORT_EMAIL,
                schedule: SCHEDULE,
                time: 0,
                isMobile: isMobile(),
                unreadMessageCounter: '0',
                supportModalIsOpen: false,
                newChat: NEW_CHAT,
                website: WEBSITE,
                footerRedirectButton: FOOTER_REDIRECT_BUTTON
            }
        },
        methods: {
            fullscreen() {
                requestFullScreen(document.body)
            },
            toggleMute() {
                this.$store.commit(MUTE, !this.mute)
            },
            showCabinetPage(page) {
                this.$store.commit(MODAL, {
                    fullscreen: true
                })

                this.$store.commit(MODAL, {
                    hamburgerMenu: false
                })

                this.$store.commit(MODAL_FULLSCREEN, {
                    page
                })
            },
            showSupportModal(){
                if(this.isMobile){
                    this.showCabinetPage('support')
                }else{
                    this.supportModalIsOpen = !this.supportModalIsOpen
                }
            },
            closeSupportModal(){
                this.supportModalIsOpen = false
            }

        },
        computed: {
            ...mapGetters(['mute', 'user', 'tokens', 'supportMessages', 'modalFullscreen','supportUnread','variables','staticBase']),
            varNames(){
                return this.variables
            }
        },
        watch: {
            supportMessages:{
                deep: true,
                handler(newVal){
                    if (newVal) {
                        let messageCounter = '0'
                        for (const n in newVal) {
                            if ((!newVal[n].time_read || newVal[n].time_read === 0)) {
                                ++messageCounter
                                if (messageCounter > 100) {
                                    this.$set(this, 'unreadMessageCounter', '99+')
                                    break
                                }
                            }
                        }

                        this.$set(this, 'unreadMessageCounter', messageCounter)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .footer {
        flex: 0 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--background-footer);
        padding: 0 15px;
        font-weight: 400;
        border-top: 1px solid var(--border);
        position: relative;
    }

    i {
        font-size: 18px;
    }

    .support-email {
        margin: 0 15px 0 0;
        color: var(--white-to-black)
    }

    .pads > * {
        margin-right: 15px;
    }

    .pads > *:last-child {
        margin-right: 0;
    }

    .pads i {
        cursor: pointer;
    }

    .live-chat {
        cursor: pointer;
    }

    .live-chat i {
        margin-right: 5px;
    }

    .blinking {
        animation: blinker 3s linear infinite
    }

    .deposit{
        color: var(--white);
        margin-left: 10px;
    }

    .app-download a{
        width: 15px;
        height: 15px;
    }
    .app-download img{
        width: 100%;
        height: 100%;
        filter: invert(100%) sepia(5%) saturate(1309%) hue-rotate(283deg) brightness(119%) contrast(104%);
    }

    .website-link a {
        text-decoration: none;
    }

    .website-link i {
        color: var(--font);
        font-size: 16px;
        display: flex;
        align-items: center;
    }

    .light-theme .app-download img {
        filter: none
    }

    @keyframes blinker {
        50% {
            color: var(--font);
        }
    }

    @media (max-width: 1000px) {
        .row{
            margin-bottom: 0;
        }
    }
</style>
